import { useEffect } from "react";
import useReveal from "../components/useReveal";

const services = [
  {
    n: "01",
    title: "Web Development",
    body:
      "Shopify stores, custom React builds, landing pages, and launch systems — designed to feel editorial, load fast, and guide people toward action.",
    chips: ["Shopify", "React", "Landing Pages"],
  },
  {
    n: "02",
    title: "SEO & Organic Growth",
    body:
      "Search visibility that compounds over time — through content architecture, technical cleanup, and pages shaped around how people actually search.",
    chips: ["Technical SEO", "Content", "Authority"],
  },
  {
    n: "03",
    title: "Meta Ads & Paid Growth",
    body:
      "Campaign systems with stronger creative, tighter landing-page alignment, and reporting that shows what happens after the click.",
    chips: ["Meta Ads", "Google Ads", "Retargeting"],
  },
  {
    n: "04",
    title: "AI Systems & Automation",
    body:
      "Practical operating systems for your business: assistants, generators, workflow rules, and human-safe automations that remove the repeat work.",
    chips: ["AI workflows", "Prompt systems", "Internal tools"],
  },
];

const processSteps = [
  {
    n: "01",
    title: "Discovery",
    body:
      "A real conversation — not a form. We come prepared with questions, and you leave with a clearer picture of what the right next move looks like.",
    chips: ["Free", "30–45 min", "No pitch"],
  },
  {
    n: "02",
    title: "Strategy & Scope",
    body:
      "We turn the conversation into a plan — with a fixed price, clear priorities, and an honest timeline. Nothing moves forward under fog.",
    chips: ["3–5 days", "Written brief", "Fixed price"],
  },
  {
    n: "03",
    title: "Build & Execute",
    body:
      "Weekly updates, clean ownership, and work designed to survive well beyond launch. Code, accounts, content, and systems — all yours.",
    chips: ["2–8 weeks", "You own everything"],
  },
  {
    n: "04",
    title: "Launch & Grow",
    body:
      "We launch together and stay close. Tracking, optimisation, and post-launch support are part of the real work — not an afterthought.",
    chips: ["Ongoing", "Monthly reports", "Always reachable"],
  },
];

export default function Services() {
  useReveal();

  useEffect(() => {
    document.title = "Services — Sutranode";
  }, []);

  return (
    <>
      <section className="section services-section page-with-nav-offset">
        <div className="container">
          <div className="section-heading" data-reveal>
            <div className="s-eyebrow">What we do</div>
            <h2 className="s-title">Designed to look sharp, and <em>keep working</em> after launch.</h2>
          </div>

          <div className="svc-list">
            {services.map((s, i) => (
              <div key={i} className="svc-item" data-reveal>
                <div className="svc-n">{s.n}</div>
                <div className="svc-body">
                  <h3>{s.title}</h3>
                  <p>{s.body}</p>
                </div>
                <div className="svc-chips">
                  {s.chips.map((c, j) => <span key={j}>{c}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section process-section">
        <div className="container">
          <div className="section-heading" data-reveal>
            <div className="s-eyebrow">How we work</div>
            <h2 className="s-title">Simple process. <em>Honest work.</em></h2>
          </div>

          <div className="process-track">
            <div className="process-thread"></div>
            {processSteps.map((step, i) => (
              <div key={i} className="ps" data-reveal>
                <div className="ps-node-wrap">
                  <div className="ps-node">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </div>
                </div>
                <div className="ps-body">
                  <div className="ps-num">{step.n}</div>
                  <h3>{step.title}</h3>
                  <p>{step.body}</p>
                  <div className="ps-chips">
                    {step.chips.map((c, j) => <span key={j}>{c}</span>)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
